module.exports = __webpack_public_path__ + "img/dashboard-icon.39d24b17.png";